import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { AdminModal } from '../../../components/admin/admin-modal';

export function BudgetYearModal({ show, onClose, handleSaveBudgetYear, initialData }) {
    const [budgetYear, setBudgetYear] = useState('');
    const [errors, setErrors] = useState('');
    const [displayError, setDisplayError] = useState('');
    const inputRef = useRef(null);

    useEffect(() => {
        if (show) {
            if (initialData) {
                setBudgetYear(initialData.budgetYear || '');
            } else {
                setBudgetYear('');
            }
            setErrors('');
            setDisplayError('');
        }
    }, [show, initialData]);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, [show]);

    const onSave = () => {
        const trimmedBudgetYear = budgetYear.trim();

        if (!trimmedBudgetYear) {
            setErrors('Budget Year must be valid.');
            return;
        }

        if (trimmedBudgetYear.toLowerCase() === 'current') {
            setErrors("'Current' is a reserved budget year and cannot be added or updated");
            return;
        }

        setErrors('');
        const updated = { ...initialData, budgetYear };
        handleSaveBudgetYear(updated);
    };

    const onCancel = () => {
        setBudgetYear('');
        setErrors('');
        onClose();
    };

    if (!show) return null;

    return (
        <AdminModal
            show={true}
            onClose={onCancel}
            onSave={onSave}
            modalTitle={initialData?.id ? 'Edit Budget Year' : 'Add Budget Year'}
            displayError={displayError}
            onHideError={() => setDisplayError('')}
            label="Budget Year"
        >
            <div className="admin-modal-row full">
                <div className="admin-modal-cell">
                    <div className={'admin-default-input-text-wrap' + (errors ? ' input-validation-error' : '')}>
                        <label className="admin-default-label">Budget Year</label>
                        <input
                            className="admin-default-input-text"
                            type="text"
                            id="budget-year"
                            value={budgetYear}
                            onChange={(e) => setBudgetYear(e.target.value)}
                            ref={inputRef}
                        />
                        {errors && <p className="validation-error-message">{errors}</p>}
                    </div>
                </div>
            </div>
        </AdminModal>
    );
}

BudgetYearModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    handleSaveBudgetYear: PropTypes.func.isRequired,
    initialData: PropTypes.object,
};
